import { render, staticRenderFns } from "./RecebimentoDeNotaFiscalVincularPedidoView.vue?vue&type=template&id=c5796c2c&scoped=true"
import script from "./RecebimentoDeNotaFiscalVincularPedidoView.vue?vue&type=script&lang=js"
export * from "./RecebimentoDeNotaFiscalVincularPedidoView.vue?vue&type=script&lang=js"
import style0 from "./RecebimentoDeNotaFiscalVincularPedidoView.vue?vue&type=style&index=0&id=c5796c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5796c2c",
  null
  
)

export default component.exports